function ConversationIcon({ width = '32', height = '32' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <g id="conversation" transform="translate(-1 -1)">
        <path
          id="Path_29662"
          data-name="Path 29662"
          d="M18.64,3.6H2.579A1.586,1.586,0,0,0,1,5.2V32.285a1.53,1.53,0,0,0,1.579,1.531H18.64a1.53,1.53,0,0,0,1.579-1.531V5.2A1.586,1.586,0,0,0,18.64,3.6Z"
          transform="translate(0 -0.815)"
          fill="#3b4150"
        />
        <path
          id="Path_29663"
          data-name="Path 29663"
          d="M3,7.4H19.542V30.683H3Z"
          transform="translate(-0.627 -2.007)"
          fill="#fff"
        />
        <path
          id="Path_29664"
          data-name="Path 29664"
          d="M15.987,5.2H12.075a.275.275,0,1,0,0,.549h3.912a.275.275,0,1,0,0-.549Z"
          transform="translate(-3.633 -1.317)"
          fill="#525252"
        />
        <path
          id="Path_29665"
          data-name="Path 29665"
          d="M25.618,1C18.891,1,13.4,4.981,13.4,9.923c0,2.677,1.579,5.011,4.118,6.658l-2.746,6.383a.452.452,0,0,0,.686.549l7.825-4.942a13.319,13.319,0,0,0,2.334.137c6.727.069,12.218-3.912,12.218-8.786C37.835,4.981,32.344,1,25.618,1Z"
          transform="translate(-4.835)"
          fill="#d40e15"
        />
        <g
          id="Group_43367"
          data-name="Group 43367"
          transform="translate(11.859 6.761)"
        >
          <path
            id="Path_29666"
            data-name="Path 29666"
            d="M20.4,10.524a1.025,1.025,0,0,0-.686.206.557.557,0,0,0-.275.549.624.624,0,0,0,.275.549,3.546,3.546,0,0,0,1.167.412,2.57,2.57,0,0,1,1.3.618,1.538,1.538,0,0,1,.48,1.167,1.719,1.719,0,0,1-.549,1.235,2.218,2.218,0,0,1-1.51.48,3.554,3.554,0,0,1-2.4-.961l.618-.755a2.75,2.75,0,0,0,1.785.755,1.233,1.233,0,0,0,.755-.206.686.686,0,0,0,0-1.1,4.042,4.042,0,0,0-.892-.343,5.766,5.766,0,0,1-.961-.275,2.782,2.782,0,0,1-.618-.343,1.414,1.414,0,0,1-.48-1.167,1.508,1.508,0,0,1,.549-1.235A2.538,2.538,0,0,1,20.4,9.7a3.109,3.109,0,0,1,1.1.206,4.193,4.193,0,0,1,.961.48l-.549.755a3,3,0,0,0-.686-.412,1.464,1.464,0,0,0-.824-.206Z"
            transform="translate(-18.2 -9.7)"
            fill="#fff"
          />
          <path
            id="Path_29667"
            data-name="Path 29667"
            d="M27.461,15.566H26.5V9.8h1.51l1.716,3.638L31.442,9.8h1.579v5.766H32.06v-4.53l-1.991,3.981H29.52L27.53,11.035v4.53Z"
            transform="translate(-20.803 -9.731)"
            fill="#fff"
          />
          <path
            id="Path_29668"
            data-name="Path 29668"
            d="M39.8,10.524a1.025,1.025,0,0,0-.686.206.557.557,0,0,0-.275.549.624.624,0,0,0,.275.549,3.546,3.546,0,0,0,1.167.412,2.57,2.57,0,0,1,1.3.618,1.538,1.538,0,0,1,.48,1.167,1.719,1.719,0,0,1-.549,1.235,2.218,2.218,0,0,1-1.51.48,3.554,3.554,0,0,1-2.4-.961l.618-.755A2.75,2.75,0,0,0,40,14.779a1.233,1.233,0,0,0,.755-.206.686.686,0,0,0,0-1.1,1.548,1.548,0,0,0-.824-.343,5.766,5.766,0,0,1-.961-.275,2.782,2.782,0,0,1-.618-.343,1.414,1.414,0,0,1-.48-1.167,1.508,1.508,0,0,1,.549-1.235A2.538,2.538,0,0,1,39.865,9.7a3.109,3.109,0,0,1,1.1.206,4.193,4.193,0,0,1,.961.48l-.549.755a3,3,0,0,0-.686-.412,1.9,1.9,0,0,0-.892-.206Z"
            transform="translate(-24.284 -9.7)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export { ConversationIcon };
